var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChainId, NATIVE_ADDRESS, WRAPPED_SOL, ZERO_ADDRESS } from '@shared/utils/config/networks';
import { useQuery } from '@tanstack/react-query';
import { transformAddress } from '@/lib/asset/nativeAddressHelper';
import { convertBasicTokenInfoToCovalentBalanceItem, getBasicTokenInfo, } from '../pricing/useBasicTokenInfo';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { stableCoins } from '@/components/explore/stableCoins';
var _getTokenData = function (tokenAddress, tokenNetwork) { return __awaiter(void 0, void 0, void 0, function () {
    var tAddress, data, sanitizedData, error_1;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                tAddress = transformAddress(tokenAddress, tokenNetwork).address;
                return [4 /*yield*/, getBasicTokenInfo(Number(tokenNetwork), tAddress, true)];
            case 1:
                data = _d.sent();
                if (tokenAddress.toLowerCase() == (NATIVE_ADDRESS === null || NATIVE_ADDRESS === void 0 ? void 0 : NATIVE_ADDRESS.toLowerCase()) ||
                    tokenAddress.toLowerCase() == ZERO_ADDRESS ||
                    tokenAddress == WRAPPED_SOL
                // || tokenAddress.toLowerCase() == WrappedNativeTokens.get(Number(tokenNetwork)).toLowerCase()
                ) {
                    if (Number(tokenNetwork) == ChainId.AVALANCHE) {
                        data.token.symbol = 'AVAX';
                        data.token.name = 'Avalanche';
                        data.token.info.imageThumbUrl = getNetworkLogo(ChainId.AVALANCHE);
                    }
                    else if (Number(tokenNetwork) == ChainId.BSC) {
                        data.token.symbol = 'BNB';
                        data.token.name = 'Binance Smart Chain';
                        data.token.info.imageThumbUrl = getNetworkLogo(ChainId.BSC);
                    }
                    else if (Number(tokenNetwork) == ChainId.POLYGON) {
                        data.token.symbol = 'POL';
                        data.token.name = 'Polygon';
                        data.token.info.imageThumbUrl = getNetworkLogo(ChainId.POLYGON);
                    }
                    else if (Number(tokenNetwork) == ChainId.SOLANA) {
                        data.token.info.imageThumbUrl = getNetworkLogo(ChainId.SOLANA);
                        data.token.symbol = 'SOL';
                        data.token.name = 'SOLANA';
                    }
                    else {
                        data.token.symbol = 'ETH';
                        data.token.name = 'Ethereum';
                        data.token.info.imageThumbUrl = getNetworkLogo(ChainId.ETHEREUM);
                    }
                }
                sanitizedData = __assign(__assign({}, data), { token: (_a = data.token) !== null && _a !== void 0 ? _a : null, tokenInfo: (_b = data.tokenInfo) !== null && _b !== void 0 ? _b : null, prices: (_c = data.prices) !== null && _c !== void 0 ? _c : null });
                return [2 /*return*/, sanitizedData];
            case 2:
                error_1 = _d.sent();
                throw new Error("_getTokenData:error:".concat(error_1));
            case 3: return [2 /*return*/];
        }
    });
}); };
var _getStableCoinsDataByNetwork = function (tokenNetwork) { return __awaiter(void 0, void 0, void 0, function () {
    var _stableCoins, _data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _stableCoins = stableCoins
                    .filter(function (_coin) { var _a; return (_a = _coin.networks) === null || _a === void 0 ? void 0 : _a.includes(tokenNetwork); })
                    .map(function (_coin) { return ({
                    name: _coin.name,
                    address: _coin.tokens[tokenNetwork],
                    network: tokenNetwork,
                }); });
                return [4 /*yield*/, Promise.all(_stableCoins.map(function (token) { return __awaiter(void 0, void 0, void 0, function () {
                        var _data, _params, _convertedAsset;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0: return [4 /*yield*/, _getTokenData(token.address, (_a = token.network) === null || _a === void 0 ? void 0 : _a.toString())];
                                case 1:
                                    _data = _c.sent();
                                    _params = {
                                        token: _data === null || _data === void 0 ? void 0 : _data.token,
                                        tokenInfo: (_b = _data === null || _data === void 0 ? void 0 : _data.tokenInfo) === null || _b === void 0 ? void 0 : _b.results,
                                        prices: [_data === null || _data === void 0 ? void 0 : _data.prices],
                                    };
                                    _convertedAsset = convertBasicTokenInfoToCovalentBalanceItem(_params);
                                    return [2 /*return*/, _convertedAsset];
                            }
                        });
                    }); }))];
            case 1:
                _data = _a.sent();
                return [2 /*return*/, _data];
            case 2:
                error_2 = _a.sent();
                throw new Error("_getStableCoinsDataByNetwork:error:".concat(error_2));
            case 3: return [2 /*return*/];
        }
    });
}); };
export var useStableCoinsData = function (tokenNetwork) {
    return useQuery({
        queryKey: ['stableCoinsQuery', tokenNetwork],
        queryFn: function () { return _getStableCoinsDataByNetwork(tokenNetwork); },
        enabled: Boolean(tokenNetwork),
    });
};
export var useTokenData = function (_a) {
    var tokenAddress = _a.tokenAddress, tokenNetwork = _a.tokenNetwork, _b = _a.refetchInterval, refetchInterval = _b === void 0 ? 5000 : _b, _c = _a.staleTime, staleTime = _c === void 0 ? 4000 : _c;
    return useQuery({
        queryKey: ['tokenData', tokenAddress, tokenNetwork],
        queryFn: function () { return _getTokenData(tokenAddress, tokenNetwork); },
        enabled: Boolean(tokenAddress && tokenNetwork),
        refetchInterval: refetchInterval,
        staleTime: staleTime,
    });
};
